import { InsertItem, Type1Item } from '../../components/addon/addons/parts/type1Class'
import { globalOnDemandVars } from '../../helper/context'
import Firestore from '../initFirebase'

export async function queryMediaItems (forWhatType1List, forWhatType) {
  const filterKey = forWhatType1List || 'type'
  const filterValue = forWhatType1List ? true : forWhatType
  // const order = forWhatType1List ? 'type1Order' : 'typeOrder'

  // const filter = {}
  // if (forWhatType1List) {
  //   filter[forWhatType1List] = { eq: true }
  // }
  // if (forWhatType) {
  //   filter.type = { eq: forWhatType }
  //   // 같은 type을 가진 것들중 가장 마지막걸 얻어내기위해서(그래서 가장 마지막 count를 얻기위해서) 밑에값이 true인걸 조건에 포함안시킴 - 포함시키고서 마지막 count얻어내게 못함?
  //   // filter.inTypeItems = true
  // }

  // const result = await client.query({
  //   query: gql(listMediaItems),
  //   // fetchPolicy: navigator.onLine ? 'network-only' : undefined,
  //   variables: {
  //     filter
  //   }
  // }).catch((e) => handleErrorInCatch(e))
  let snapshot = await Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('MediaItems').where(filterKey, '==', filterValue).get()
  if (snapshot.empty) {
    return []
  }
  const results = []
  snapshot.forEach((doc) => {
    results.push({
      id: doc.id,
      ...doc.data()
    })
  })
  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'queryMediaItems',
      value: {
        results
      }
    // , important: true
    })
  }

  let returnValue
  if (results) {
    returnValue = Array.from(results)
    returnValue.forEach((item) => {
      try {
        if (item.type !== 'Code' && item.type !== 'LaTeX') { item.content = JSON.parse(item.content) }

        //  for legacy
        const content = item.content
        if (typeof content === 'object') {
          if (content.image) {
            content.isImage = true
          }
          if (content.customCoordinates) {
            content.cropConfig = content.customCoordinates
          }
        }
      } catch (e) {
        return null
      }
    })
  } else {
    returnValue = []
  }

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'queryMediaItems',
      value: {
        results,
        forWhatType,
        forWhatType1List,
        returnValue
      }
    // , important: true
    })
  }

  return returnValue
}

// -----------------------------------------------------------------------------------------------------------

export async function initType1Lists () {
  globalOnDemandVars.set_type1Ready(false)
  let inType1Items = await queryMediaItems('inType1Items')

  inType1Items.sort((a, b) => {
    if (a.type1Order === b.type1Order) {
      return b.creationTimeValue - a.creationTimeValue
    } else {
      return a.type1Order - b.type1Order
    }
  })

  inType1Items = inType1Items.map((item) => (new Type1Item(item.type, item.title, item.content, item.localId, (item.backId || extractCountForId(item.localId)), item.id, item.inWaitingItemsForType1, item.inUsedItemsForType1)))

  const inWaitingItemsForType1 = inType1Items.filter((item) => (item.inWaitingItemsForType1))

  const inUsedItemsForType1 = inType1Items.filter((item) => (item.inUsedItemsForType1))

  // const itemsArray = [inType1Items, inWaitingItemsForType1, inUsedItemsForType1]
  //
  // const [inType1Items, inWaitingItemsForType1, inUsedItemsForType1] = itemsArray

  globalOnDemandVars.set_type1Items(inType1Items)
  globalOnDemandVars.set_waitingItemsForType1(inWaitingItemsForType1)
  globalOnDemandVars.set_usedItemsForType1(inUsedItemsForType1)
  globalOnDemandVars.set_type1Ready(true)
}

// -----------------------------------------------------------------------------------------------------------
const regexForNumber = /\d+/
export const extractCountForId = (id) => {
  return Number(regexForNumber.exec(id)[0])
}
async function initTypeItemList (type) {
  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('media / initTypeItemList 시작')
  }
  const items = await queryMediaItems(false, type).catch(e => {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'MediaItem / initTypeItemLists',
        value: {
          e
        }
      // , important: true
      })
    }
  })
  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('media / initTypeItemLists await 통과')
  }

  const countReference = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('MediaItems').doc(`Count`)
  let countData = await countReference.get()
  countData = countData.data() && countData.data()[type]
  if (!countData) {
    await countReference.set({
      [type]: 1
    }, { merge: true })
    globalOnDemandVars[`set_CountFor${type}`](1)
  } else {
    globalOnDemandVars[`set_CountFor${type}`](countData)
  }
  // count = extractCountForId(items[items.length - 1].localId)
  // globalOnDemandVars[`set_CountFor${type}`](countData + 1)

  let currentItems = items.filter((item) => (item.inTypeItems))
  currentItems.sort((a, b) => {
    if (a.typeOrder === b.typeOrder) {
      return b.creationTimeValue - a.creationTimeValue
    } else {
      return a.typeOrder - b.typeOrder
    }
  })
  currentItems = currentItems.map((item) => (new InsertItem(item.type, item.title, item.content, extractCountForId(item.localId), item.id, item.localId)))

  globalOnDemandVars[`set_itemsFor${type}`](currentItems)
}

export async function initTypeItemLists (types) {
  globalOnDemandVars.set_typeListsReady(false)
  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('MediaItem initTypeItemLists 시작')
  }
  await Promise.all(types.map((type) => (initTypeItemList(type)))).catch((e) => {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'MediaItem / initTypeItemLists',
        value: {
          e
        }
      // , important: true
      })
    }
  })

  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('MediaItem initTypeItemLists 무사통과')
  }
  globalOnDemandVars.set_typeListsReady(true)
}
